// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-connect-web v0.11.0 with parameter "target=js,import_extension=none"
// @generated from file msh/service/v1/account_manager.proto (package msh.service.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AcceptUserInvitationRequest, AcceptUserInvitationResponse, AddBusinessAccountUserRequest, AddBusinessAccountUserResponse, AddBusinessStructureUserRequest, AddBusinessStructureUserResponse, AddConsumerAccountUserRequest, AddConsumerAccountUserResponse, AuthenticateDeviceTokenRequest, AuthenticateDeviceTokenResponse, CreateBusinessAccountRequest, CreateBusinessAccountResponse, CreateConsumerAccountRequest, CreateConsumerAccountResponse, GetAccountRequest, GetAccountResponse, GetCurrentAccountsRequest, GetCurrentAccountsResponse, GetStructureUsersRequest, GetStructureUsersResponse, GetUserInvitationsRequest, GetUserInvitationsResponse, GetUserRequest, GetUserResponse, InviteBusinessStructureUserRequest, InviteBusinessStructureUserResponse, InviteConsumerAccountUserRequest, InviteConsumerAccountUserResponse, RefuseUserInvitationRequest, RefuseUserInvitationResponse, RegisterForPushNotificationRequest, RegisterForPushNotificationResponse, SetUserContactTimeRequest, SetUserContactTimeResponse, UnregisterForPushNotificationRequest, UnregisterForPushNotificationResponse } from "./account_manager_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service msh.service.v1.AccountManager
 */
export const AccountManager = {
  typeName: "msh.service.v1.AccountManager",
  methods: {
    /**
     *
     * Used to create a Consumer account
     * This will create the account and set the user information
     *
     * Returns both the account and manager user account
     *
     * @generated from rpc msh.service.v1.AccountManager.CreateConsumerAccount
     */
    createConsumerAccount: {
      name: "CreateConsumerAccount",
      I: CreateConsumerAccountRequest,
      O: CreateConsumerAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Used to create a Business account
     * This will create the account and set the user information
     * to create the initial manager of the business account.
     *
     * Returns both the account and manager user account
     *
     * @generated from rpc msh.service.v1.AccountManager.CreateBusinessAccount
     */
    createBusinessAccount: {
      name: "CreateBusinessAccount",
      I: CreateBusinessAccountRequest,
      O: CreateBusinessAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AccountManager.AddBusinessAccountUser
     */
    addBusinessAccountUser: {
      name: "AddBusinessAccountUser",
      I: AddBusinessAccountUserRequest,
      O: AddBusinessAccountUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AccountManager.AddBusinessStructureUser
     */
    addBusinessStructureUser: {
      name: "AddBusinessStructureUser",
      I: AddBusinessStructureUserRequest,
      O: AddBusinessStructureUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AccountManager.AddConsumerAccountUser
     */
    addConsumerAccountUser: {
      name: "AddConsumerAccountUser",
      I: AddConsumerAccountUserRequest,
      O: AddConsumerAccountUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AccountManager.InviteConsumerAccountUser
     */
    inviteConsumerAccountUser: {
      name: "InviteConsumerAccountUser",
      I: InviteConsumerAccountUserRequest,
      O: InviteConsumerAccountUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AccountManager.InviteBusinessStructureUser
     */
    inviteBusinessStructureUser: {
      name: "InviteBusinessStructureUser",
      I: InviteBusinessStructureUserRequest,
      O: InviteBusinessStructureUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AccountManager.GetUserInvitations
     */
    getUserInvitations: {
      name: "GetUserInvitations",
      I: GetUserInvitationsRequest,
      O: GetUserInvitationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AccountManager.GetStructureUsers
     */
    getStructureUsers: {
      name: "GetStructureUsers",
      I: GetStructureUsersRequest,
      O: GetStructureUsersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AccountManager.AcceptUserInvitation
     */
    acceptUserInvitation: {
      name: "AcceptUserInvitation",
      I: AcceptUserInvitationRequest,
      O: AcceptUserInvitationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AccountManager.RefuseUserInvitation
     */
    refuseUserInvitation: {
      name: "RefuseUserInvitation",
      I: RefuseUserInvitationRequest,
      O: RefuseUserInvitationResponse,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Function to get the user account. It will check to see
     * if the user calling this call has account to the user
     * in which the account belongs.
     *
     * Input parameter is the user_id to retrieve.
     *
     * Returns the User information or throws NOT_FOUND.
     *
     * @generated from rpc msh.service.v1.AccountManager.GetUser
     */
    getUser: {
      name: "GetUser",
      I: GetUserRequest,
      O: GetUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AccountManager.GetAccount
     */
    getAccount: {
      name: "GetAccount",
      I: GetAccountRequest,
      O: GetAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Function to return the current accounts linked to the session. Useful when
     * we don't have the account_id for the user.
     *
     * @generated from rpc msh.service.v1.AccountManager.GetCurrentAccounts
     */
    getCurrentAccounts: {
      name: "GetCurrentAccounts",
      I: GetCurrentAccountsRequest,
      O: GetCurrentAccountsResponse,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Function to set contact times on user.
     *
     * @generated from rpc msh.service.v1.AccountManager.SetUserContactTime
     */
    setUserContactTime: {
      name: "SetUserContactTime",
      I: SetUserContactTimeRequest,
      O: SetUserContactTimeResponse,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Get a custom token from Firebase to 'login' using the device cryptochip valid jwt.
     * This will use the firebase client to obtain a valid token to be used with the gRPC endpoint.
     *
     * @generated from rpc msh.service.v1.AccountManager.AuthenticateDeviceToken
     */
    authenticateDeviceToken: {
      name: "AuthenticateDeviceToken",
      I: AuthenticateDeviceTokenRequest,
      O: AuthenticateDeviceTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Register a cell phone for push notification
     *
     * @generated from rpc msh.service.v1.AccountManager.RegisterForPushNotification
     */
    registerForPushNotification: {
      name: "RegisterForPushNotification",
      I: RegisterForPushNotificationRequest,
      O: RegisterForPushNotificationResponse,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Register a cell phone for push notification
     *
     * @generated from rpc msh.service.v1.AccountManager.UnregisterForPushNotification
     */
    unregisterForPushNotification: {
      name: "UnregisterForPushNotification",
      I: UnregisterForPushNotificationRequest,
      O: UnregisterForPushNotificationResponse,
      kind: MethodKind.Unary,
    },
  }
};

